export default __webpack_public_path__ + "static/media/27.2c10a167.png";